import { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { useCookies } from 'react-cookie';
import { ThemeContext } from '../context/Theme';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import ReactPaginate from 'react-paginate';
import { MultiSelect } from 'react-multi-select-component';
import Calendar from 'react-calendar';
import { Link } from 'react-router-dom';
import ComponenteTablaLight from '../components/NuevaTabla/Light/ComponenteTablaLight/ComponenteTablaLight';
import './tabla2026.css';
export default function Tabla2026Cargas() {
  const [cookies, setCookie] = useCookies(['user']);
  //const [denunciasRapido, setDenunciasRapido] = useState([])
  const [denuncias, setDenuncias] = useState([]);
  const [codigos, setCodigos] = useState([]);
  const [estados, setEstados] = useState([]);
  const [isCalendar, setIsCalendar] = useState(0);
  const [ampSinLeer, setAmpSinLeer] = useState(null);
  const [buscando, setBuscando] = useState(false);
  const [sinResultados, setSinResultados] = useState(false);
  // valor de filtro para calendario
  const [value, onChange] = useState(null);
  // Array a buscar en db y uso para filtros
  useEffect(() => {
    const fetchDataInStages = async () => {
      try {
        setBuscando(true);
        const amp = await axios.get('https://back.agsseguros.online/api/ampliaciones/noLeidoAll');
        setAmpSinLeer(amp.data);
        const estadosN = await axios.get('https://back.agsseguros.online/api/estados/estadosAll');
        setEstados(estadosN.data);
        const codigos = await axios.get('https://back.agsseguros.online/api/estados/codigoAll');
        setCodigos(codigos.data);
        //
        const hoy = new Date();
        let mesesABuscar = 0;
        if (cookies.user.depto === 'cargas') mesesABuscar = 1;
        else if (cookies.user.depto === 'contractuales') mesesABuscar = 1;
        else if (cookies.user.depto === 'choques') mesesABuscar = 0;
        else if (cookies.user.depto === 'admin') mesesABuscar = 1;
        for (let i = 0; i < mesesABuscar; i++) {
          const fecha = new Date(hoy.getFullYear(), hoy.getMonth() - i, 1);
          const year = fecha.getFullYear();
          const month = fecha.getMonth() + 1;
          try {
            const mesStr = month.toString().padStart(2, '0');
            const res = await axios.get(`https://back.agsseguros.online/api/tabla2026/buscar/${year}/${mesStr}`);
            setDenuncias(prev => {
              const existingIds = new Set(prev.map(d => d.id));
              const nuevos = res.data.reverse().filter(d => !existingIds.has(d.id));
              return [...prev, ...nuevos];
            });
          } catch (err) {
            console.error(`Error al buscar ${year}-${month}:`, err);
          }
        }
        setBuscando(false);
        const asignadoRes = await axios.get(`https://back.agsseguros.online/api/asignadoCarga`, { params: { asignado: cookies.user.usuario } });
        setCookie('asignado', JSON.stringify(asignadoRes.data), { path: '/' });
      } catch (error) {
        console.error('Error fetching data', error);
      }
    };
    fetchDataInStages();
  }, [cookies.user.usuario, setCookie]);
  let itemsPerPage = 200;
  const [itemOffset, setItemOffset] = useState(0);
  const pageCount = Math.ceil(denuncias.length / itemsPerPage);
  const [currentPage, setCurrentPage] = useState(0);
  const handlePageClick = event => {
    const newOffset = (event.selected * itemsPerPage) % denuncias.length;
    setItemOffset(newOffset);
    setCurrentPage(event.selected);
  };
  // filtros
  const [info, setInfo] = useState({
    buscarGeneral2: '',
    nroStro: '',
    poliza: '',
    tipoStro: [],
    catStro: [],
    estado: [],
    fechaStro: '',
    codp: '',
    asignado: [],
    sicobe: [],
    prioridad: [],
    vencimiento: [],
    dominio: '',
    dominio3ro: '',
  });
  // valores para filtros
  // asignados
  const optionsCarga = [
    { value: 'JuanG', label: 'JuanG', key: 1 },
    { value: 'LucaP', label: 'LucaP', key: 2 },
    { value: 'StellaM', label: 'StellaM', key: 3 },
    { value: 'DanielaM', label: 'DanielaM', key: 4 },
    { value: 'rosario', label: 'rosario', key: 5 },
  ];
  const optionsChoque = [
    { value: 'JuanG', label: 'JuanG', key: 1 },
    { value: 'LucaP', label: 'LucaP', key: 2 },
    { value: 'DanielaM', label: 'DanielaM', key: 3 },
    { value: 'DiegoD', label: 'DiegoD', key: 4 },
    { value: 'DiegoS', label: 'DiegoS', key: 5 },
    { value: 'OrelyC', label: 'OrelyC', key: 6 },
    { value: 'StellaM', label: 'StellaM', key: 7 },
    { value: 'LucianaF', label: 'LucianaF', key: 8 },
    { value: 'CandelaS', label: 'CandelaS', key: 9 },
    { value: 'MagaliG', label: 'MagaliG', key: 10 },
    { value: 'PilarS', label: 'PilarS', key: 11 },
    { value: 'Maurom', label: 'Maurom', key: 12 },
    { value: 'ClaudiaF', label: 'ClaudiaF', key: 13 },
    { value: 'Gian', label: 'Gian', key: 14 },
    { value: 'rosario', label: 'rosario', key: 15 },
  ];
  const optionsContractuales = [
    { value: 'JuanG', label: 'JuanG', key: 1 },
    { value: 'LucaP', label: 'LucaP', key: 2 },
    { value: 'DanielaM', label: 'DanielaM', key: 3 },
    { value: 'DiegoD', label: 'DiegoD', key: 4 },
    { value: 'DiegoS', label: 'DiegoS', key: 5 },
    { value: 'OrelyC', label: 'OrelyC', key: 6 },
    { value: 'StellaM', label: 'StellaM', key: 7 },
    { value: 'LucianaF', label: 'LucianaF', key: 8 },
    { value: 'CandelaS', label: 'CandelaS', key: 9 },
    { value: 'MagaliG', label: 'MagaliG', key: 10 },
    { value: 'PilarS', label: 'PilarS', key: 11 },
    { value: 'Augusto', label: 'Augusto', key: 12 },
    { value: 'PaulaC', label: 'PaulaC', key: 13 },
    { value: 'MariaE', label: 'MariaE', key: 14 },
    { value: 'rosario', label: 'rosario', key: 15 },
  ];
  // tipo stro
  const optionsTipoStro = [
    { label: 'ACCIDENTE DE TRANSITO', value: 'ACCIDENTE DE TRANSITO' },
    { label: 'CONTRACTUAL', value: 'CONTRACTUAL' },
    { label: 'ROBO TOTAL', value: 'ROBO TOTAL' },
    { label: 'ROBO PARCIAL', value: 'ROBO PARCIAL' },
    { label: 'ROBO PARCIAL INSP', value: 'ROBO PARCIAL INSP' },
    { label: 'INCENDIO TOTAL', value: 'INCENDIO TOTAL' },
    { label: 'INCENDIO PARCIAL', value: 'INCENDIO PARCIAL' },
    { label: 'DAÑO TOTAL', value: 'DAÑO TOTAL' },
    { label: 'DAÑO PARCIAL', value: 'DAÑO PARCIAL' },
  ];
  // resp
  const responsabilidadInput = [
    { label: 'Cr', value: 320 },
    { label: 'Cc', value: 320 },
    { label: 'Sr', value: 300 },
    { label: 'Rp', value: 400 },
    { label: 'Rp1 (1 ruedas)', value: 401 },
    { label: 'Rp2 (2 ruedas)', value: 402 },
    { label: 'Rp3 (3 ruedas)', value: 403 },
    { label: 'Rp4 (4 ruedas)', value: 404 },
    { label: 'Rp5 (5 ruedas)', value: 405 },
    { label: 'Rt', value: 500 },
    { label: 'Ra', value: 550 },
    { label: 'Raf', value: 551 },
    { label: 'Ip', value: 600 },
    { label: 'Dp', value: 800 },
    { label: 'Dt', value: 900 },
    { label: 'Aseg les', value: 100 },
    { label: 'Aseg muerto', value: 130 },
    { label: '3ro les', value: 200 },
    { label: '3ro muerto', value: 230 },
    { label: '3ro muerto Rec', value: 233 },
  ];
  const responsabilidadChoques = [
    { label: 'Cr', value: 320 },
    { label: 'Cc', value: 320 },
    { label: 'Sr', value: 300 },
    { label: '3ro les', value: 200 },
    { label: '3ro muerto', value: 230 },
    { label: '3ro muerto Rec', value: 233 },
  ];
  const responsabilidadRoboParcialInsp = [
    { label: 'Rp1 (1 ruedas)', value: 401 },
    { label: 'Rp2 (2 ruedas)', value: 402 },
    { label: 'Rp3 (3 ruedas)', value: 403 },
    { label: 'Rp4 (4 ruedas)', value: 404 },
    { label: 'Rp5 (5 ruedas)', value: 405 },
    { label: 'Ra', value: 550 },
    { label: 'Raf', value: 551 },
  ];
  const responsabilidadRoboTotal = [{ label: 'Rt', value: 500 }];
  const responsabilidadRoboParcial = [{ label: 'Rp', value: 400 }];
  const responsabilidadDanioParcial = [{ label: 'Dp', value: 800 }];
  const responsabilidadIncendioTotal = [];
  const responsabilidadIncendioParcial = [{ label: 'Ip', value: 600 }];
  const responsabilidadDanioTotal = [{ label: 'Dt', value: 900 }];
  // sicobe
  const sicobeOptions = [
    { value: 1, label: 'COBERTURA', key: 1 },
    { value: 2, label: 'EN REVISION', key: 2 },
    { value: 3, label: 'COBERTURA ANALIZADO POR COBRANZAS', key: 3 },
    { value: 4, label: 'SIN COBERTURA ANALIZADO POR COBRANZAS', key: 4 },
    { value: 5, label: 'PARA IMPUTAR', key: 5 },
  ];
  // prioridad
  const optionsPrioridad = [
    { label: 'BAJA', value: 1 },
    { label: 'MEDIA', value: 2 },
    { label: 'ALTA', value: 3 },
  ];
  // vencimiento
  const optionsVencimiento = [
    { label: 'HOY', value: 1 },
    { label: 'MAÑANA', value: 2 },
    { label: 'VENCIDOS', value: 3 },
  ];
  // calendario
  const optionsCalendar = [
    { label: 'Filtro Fecha Recepcion', value: 0 },
    { label: 'Filtro Fecha Vencimiento', value: 1 },
    { label: 'Filtro Fecha Reclamo Recibido', value: 2 },
    { label: 'Fecha Enviado a Cotizar', value: 3 },
  ];
  const handleChange1 = event => {
    setIsCalendar(event.target.value);
  };
  // Estados para el rango
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const handleClick = date => {
    if (!startDate || (startDate && endDate)) {
      setStartDate(date);
      setEndDate(null);
    } else {
      if (date < startDate) {
        setEndDate(startDate);
        setStartDate(date);
      } else {
        setEndDate(date);
      }
    }
  };
  const isInRange = date => {
    if (!startDate) return false;
    if (!endDate) return date.getTime() === startDate.getTime();
    return date >= startDate && date <= endDate;
  };
  const codigosA = cookies?.user?.codigosPermitidos;
  const codigosANumeros = codigosA.split(',').map(c => Number(c.trim()));
  if (cookies.user.id === 100) {
    denuncias = denuncias.filter(s => codigosANumeros.includes(s.codp));
  }
  const exportToExcel = () => {
    if (!denuncias || denuncias.length === 0) return;
    const dataToExport = denuncias.map(item => ({
      nroStro: item.nroStro?.toString().slice(3) ?? '',
    }));
    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Stros');
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(data, 'stros.xlsx');
  };
  // buscar
  const buscar = async () => {
    try {
      setDenuncias([]);
      setBuscando(true);
      const formatDate = date => {
        if (!date) return null;
        return new Date(date).toISOString().split('T')[0];
      };
      const params = {
        ...info,
        prioridad: info.prioridad.map(e => e.value),
        estado: info.estado.map(e => e.value),
        tipoStro: info.tipoStro.map(e => e.value),
        asignado: info.asignado.map(e => e.value),
        sicobe: info.sicobe.map(e => e.value),
        catStro: info.catStro.map(e => e.value),
        startDate: formatDate(startDate),
        endDate: formatDate(endDate),
        isCalendar,
      };
      const res = await axios.get('https://back.agsseguros.online/api/tabla2026/buscarConFiltros', {
        params: params,
      });
      setDenuncias(res.data.reverse());
      setBuscando(false);
    } catch (error) {
      console.error(error);
    } finally {
      setBuscando(false);
    }
  };
  // vaciar
  const vaciar = async () => {
    try {
      setDenuncias([]);
      setInfo({
        buscarGeneral2: '',
        nroStro: '',
        poliza: '',
        tipoStro: [],
        catStro: [],
        estado: [],
        fechaStro: '',
        codp: '',
        asignado: [],
        sicobe: [],
        prioridad: [],
        vencimiento: [],
        dominio: '',
        dominio3ro: '',
      });
      setIsCalendar(0);
      setEndDate(null);
      setStartDate(null);
      onChange(null);
      setBuscando(true);
      const hoy = new Date();
      let mesesABuscar = 0;
      if (cookies.user.depto === 'cargas') mesesABuscar = 1;
      else if (cookies.user.depto === 'contractuales') mesesABuscar = 1;
      else if (cookies.user.depto === 'choques') mesesABuscar = 0;
      else if (cookies.user.depto === 'admin') mesesABuscar = 1;
      for (let i = 0; i < mesesABuscar; i++) {
        const fecha = new Date(hoy.getFullYear(), hoy.getMonth() - i, 1);
        const year = fecha.getFullYear();
        const month = fecha.getMonth() + 1;
        try {
          const mesStr = month.toString().padStart(2, '0');
          const res = await axios.get(`https://back.agsseguros.online/api/tabla2026/buscar/${year}/${mesStr}`);
          setDenuncias(prev => {
            const existingIds = new Set(prev.map(d => d.id));
            const nuevos = res.data.reverse().filter(d => !existingIds.has(d.id));
            return [...prev, ...nuevos];
          });
        } catch (err) {
          console.error(`Error al buscar ${year}-${month}:`, err);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setBuscando(false);
    }
  };
  return (
    <main className='mainTabla2026'>
      <div className='headerTabla2026'>
        <div className='contenedorPrincipalHeaderTabla2026'>
          <div className='contenedorFiltrosTabla2026'>
            <div className='conteendorPrimerFilaFiltrosTabla2026'>
              <div className='elementoMultipleTabla2026Filtros'>
                <input
                  class='inputBuscarTabla2026'
                  type='text'
                  placeholder='BUSCAR'
                  value={info.buscarGeneral2}
                  onChange={e =>
                    setInfo(prevState => ({
                      ...prevState,
                      buscarGeneral2: e.target.value,
                    }))
                  }
                />
                <input
                  class='inputBuscarTabla2026'
                  type='text'
                  placeholder='NRO STRO'
                  value={info.nroStro}
                  onChange={e =>
                    setInfo(prevState => ({
                      ...prevState,
                      nroStro: e.target.value,
                    }))
                  }
                />
                <input
                  class='inputBuscarTabla2026'
                  type='text'
                  placeholder='POLIZA'
                  value={info.poliza}
                  onChange={e =>
                    setInfo(prevState => ({
                      ...prevState,
                      poliza: e.target.value,
                    }))
                  }
                />
              </div>
              <MultiSelect
                disabled={cookies.user.id === 107 ? true : false}
                className='w-100'
                options={optionsTipoStro}
                value={info.tipoStro}
                valueRenderer={(selected, _options) => {
                  return selected.length ? selected.map(({ label }) => label) : 'TIPO STRO';
                }}
                onChange={e => {
                  const includesContractual = e.some(opt => opt.value === 'CONTRACTUAL');
                  const wasContractualSelected = info.tipoStro.some(opt => opt.value === 'CONTRACTUAL');
                  let newSelection = e;
                  if (includesContractual && !wasContractualSelected) {
                    newSelection = optionsTipoStro.filter(opt => opt.value !== 'ACCIDENTE DE TRANSITO');
                  } else if (!includesContractual && wasContractualSelected) {
                    newSelection = [];
                  }
                  setInfo(prev => ({
                    ...prev,
                    tipoStro: newSelection,
                    estado: [],
                    responsabilidad: [],
                  }));
                }}
              />
              {info.tipoStro[0] && info.tipoStro[0].value === 'ACCIDENTE DE TRANSITO' ? (
                <MultiSelect
                  disabled={cookies.user.id === 107 ? true : false}
                  className='w-100'
                  options={responsabilidadChoques}
                  value={info.catStro}
                  valueRenderer={(selected, _options) => {
                    return selected.length ? selected.map(({ label }) => label) : 'RESPONSABILIDAD';
                  }}
                  onChange={e => {
                    const value = Number(e);
                    let tipoStro = null;
                    if (value[0]) {
                      if (value[0].value === 320 || value[0].value === 300 || value[0].value === 200 || value[0].value === 230 || value[0].value === 233) {
                        tipoStro = 'ACCIDENTE DE TRANSITO';
                      } else if (value[0].value === 500) {
                        tipoStro = 'ROBO TOTAL';
                      } else if (value[0].value === 400) {
                        tipoStro = 'ROBO PARCIAL';
                      } else if (value[0].value === 401 || value[0].value === 402 || value[0].value === 403 || value[0].value === 550 || value[0].value === 551) {
                        tipoStro = 'ROBO PARCIAL INSP';
                      } else if (value[0].value === 600) {
                        tipoStro = 'INCENDIO PARCIAL';
                      } else if (value[0].value === 900) {
                        tipoStro = 'DAÑO TOTAL';
                      } else if (value[0].value === 800) {
                        tipoStro = 'DAÑO PARCIAL';
                      }
                    }
                    setInfo(prevState => ({
                      ...prevState,
                      catStro: e,
                      estado: [],
                      tipoStro: value[0] ? [{ value: tipoStro, label: tipoStro }] : info.tipoStro,
                    }));
                  }}
                />
              ) : info.tipoStro[0] && info.tipoStro[0].value === 'ROBO TOTAL' ? (
                <MultiSelect
                  disabled={cookies.user.id === 107 ? true : false}
                  className='w-100'
                  options={responsabilidadRoboTotal}
                  value={info.catStro}
                  valueRenderer={(selected, _options) => {
                    return selected.length ? selected.map(({ label }) => label) : 'RESPONSABILIDAD';
                  }}
                  onChange={e => {
                    const value = Number(e);
                    let tipoStro = null;
                    if (value[0]) {
                      if (value[0].value === 320 || value[0].value === 300 || value[0].value === 200 || value[0].value === 230 || value[0].value === 233) {
                        tipoStro = 'ACCIDENTE DE TRANSITO';
                      } else if (value[0].value === 500) {
                        tipoStro = 'ROBO TOTAL';
                      } else if (value[0].value === 400) {
                        tipoStro = 'ROBO PARCIAL';
                      } else if (value[0].value === 401 || value[0].value === 402 || value[0].value === 403 || value[0].value === 550 || value[0].value === 551) {
                        tipoStro = 'ROBO PARCIAL INSP';
                      } else if (value[0].value === 600) {
                        tipoStro = 'INCENDIO PARCIAL';
                      } else if (value[0].value === 900) {
                        tipoStro = 'DAÑO TOTAL';
                      } else if (value[0].value === 800) {
                        tipoStro = 'DAÑO PARCIAL';
                      }
                    }
                    setInfo(prevState => ({
                      ...prevState,
                      catStro: e,
                      estado: [],
                      tipoStro: value[0] ? [{ value: tipoStro, label: tipoStro }] : info.tipoStro,
                    }));
                  }}
                />
              ) : info.tipoStro[0] && info.tipoStro[0].value === 'ROBO PARCIAL' ? (
                <MultiSelect
                  disabled={cookies.user.id === 107 ? true : false}
                  className='w-100'
                  options={responsabilidadRoboParcial}
                  value={info.catStro}
                  valueRenderer={(selected, _options) => {
                    return selected.length ? selected.map(({ label }) => label) : 'RESPONSABILIDAD';
                  }}
                  onChange={e => {
                    const value = Number(e);
                    let tipoStro = null;
                    if (value[0]) {
                      if (value[0].value === 320 || value[0].value === 300 || value[0].value === 200 || value[0].value === 230 || value[0].value === 233) {
                        tipoStro = 'ACCIDENTE DE TRANSITO';
                      } else if (value[0].value === 500) {
                        tipoStro = 'ROBO TOTAL';
                      } else if (value[0].value === 400) {
                        tipoStro = 'ROBO PARCIAL';
                      } else if (value[0].value === 401 || value[0].value === 402 || value[0].value === 403 || value[0].value === 550 || value[0].value === 551) {
                        tipoStro = 'ROBO PARCIAL INSP';
                      } else if (value[0].value === 600) {
                        tipoStro = 'INCENDIO PARCIAL';
                      } else if (value[0].value === 900) {
                        tipoStro = 'DAÑO TOTAL';
                      } else if (value[0].value === 800) {
                        tipoStro = 'DAÑO PARCIAL';
                      }
                    }
                    setInfo(prevState => ({
                      ...prevState,
                      catStro: e,
                      estado: [],
                      tipoStro: value[0] ? [{ value: tipoStro, label: tipoStro }] : info.tipoStro,
                    }));
                  }}
                />
              ) : info.tipoStro[0] && info.tipoStro[0].value === 'ROBO PARCIAL INSP' ? (
                <MultiSelect
                  disabled={cookies.user.id === 107 ? true : false}
                  className='w-100'
                  options={responsabilidadRoboParcialInsp}
                  value={info.catStro}
                  valueRenderer={(selected, _options) => {
                    return selected.length ? selected.map(({ label }) => label) : 'RESPONSABILIDAD';
                  }}
                  onChange={e => {
                    const value = Number(e);
                    let tipoStro = null;
                    if (value[0]) {
                      if (value[0].value === 320 || value[0].value === 300 || value[0].value === 200 || value[0].value === 230 || value[0].value === 233) {
                        tipoStro = 'ACCIDENTE DE TRANSITO';
                      } else if (value[0].value === 500) {
                        tipoStro = 'ROBO TOTAL';
                      } else if (value[0].value === 400) {
                        tipoStro = 'ROBO PARCIAL';
                      } else if (value[0].value === 401 || value[0].value === 402 || value[0].value === 403 || value[0].value === 550 || value[0].value === 551) {
                        tipoStro = 'ROBO PARCIAL INSP';
                      } else if (value[0].value === 600) {
                        tipoStro = 'INCENDIO PARCIAL';
                      } else if (value[0].value === 900) {
                        tipoStro = 'DAÑO TOTAL';
                      } else if (value[0].value === 800) {
                        tipoStro = 'DAÑO PARCIAL';
                      }
                    }
                    setInfo(prevState => ({
                      ...prevState,
                      catStro: e,
                      estado: [],
                      tipoStro: value[0] ? [{ value: tipoStro, label: tipoStro }] : info.tipoStro,
                    }));
                  }}
                />
              ) : info.tipoStro[0] && info.tipoStro[0].value === 'INCENDIO TOTAL' ? (
                <MultiSelect
                  disabled={cookies.user.id === 107 ? true : false}
                  className='w-100'
                  options={responsabilidadIncendioTotal}
                  value={info.catStro}
                  valueRenderer={(selected, _options) => {
                    return selected.length ? selected.map(({ label }) => label) : 'RESPONSABILIDAD';
                  }}
                  onChange={e => {
                    const value = Number(e);
                    let tipoStro = null;
                    if (value[0]) {
                      if (value[0].value === 320 || value[0].value === 300 || value[0].value === 200 || value[0].value === 230 || value[0].value === 233) {
                        tipoStro = 'ACCIDENTE DE TRANSITO';
                      } else if (value[0].value === 500) {
                        tipoStro = 'ROBO TOTAL';
                      } else if (value[0].value === 400) {
                        tipoStro = 'ROBO PARCIAL';
                      } else if (value[0].value === 401 || value[0].value === 402 || value[0].value === 403 || value[0].value === 550 || value[0].value === 551) {
                        tipoStro = 'ROBO PARCIAL INSP';
                      } else if (value[0].value === 600) {
                        tipoStro = 'INCENDIO PARCIAL';
                      } else if (value[0].value === 900) {
                        tipoStro = 'DAÑO TOTAL';
                      } else if (value[0].value === 800) {
                        tipoStro = 'DAÑO PARCIAL';
                      }
                    }
                    setInfo(prevState => ({
                      ...prevState,
                      catStro: e,
                      estado: [],
                      tipoStro: value[0] ? [{ value: tipoStro, label: tipoStro }] : info.tipoStro,
                    }));
                  }}
                />
              ) : info.tipoStro[0] && info.tipoStro[0].value === 'INCENDIO PARCIAL' ? (
                <MultiSelect
                  disabled={cookies.user.id === 107 ? true : false}
                  className='w-100'
                  options={responsabilidadIncendioParcial}
                  value={info.catStro}
                  valueRenderer={(selected, _options) => {
                    return selected.length ? selected.map(({ label }) => label) : 'RESPONSABILIDAD';
                  }}
                  onChange={e => {
                    const value = Number(e);
                    let tipoStro = null;
                    if (value[0]) {
                      if (value[0].value === 320 || value[0].value === 300 || value[0].value === 200 || value[0].value === 230 || value[0].value === 233) {
                        tipoStro = 'ACCIDENTE DE TRANSITO';
                      } else if (value[0].value === 500) {
                        tipoStro = 'ROBO TOTAL';
                      } else if (value[0].value === 400) {
                        tipoStro = 'ROBO PARCIAL';
                      } else if (value[0].value === 401 || value[0].value === 402 || value[0].value === 403 || value[0].value === 550 || value[0].value === 551) {
                        tipoStro = 'ROBO PARCIAL INSP';
                      } else if (value[0].value === 600) {
                        tipoStro = 'INCENDIO PARCIAL';
                      } else if (value[0].value === 900) {
                        tipoStro = 'DAÑO TOTAL';
                      } else if (value[0].value === 800) {
                        tipoStro = 'DAÑO PARCIAL';
                      }
                    }
                    setInfo(prevState => ({
                      ...prevState,
                      catStro: e,
                      estado: [],
                      tipoStro: value[0] ? [{ value: tipoStro, label: tipoStro }] : info.tipoStro,
                    }));
                  }}
                />
              ) : info.tipoStro[0] && info.tipoStro[0].value === 'DAÑO TOTAL' ? (
                <MultiSelect
                  disabled={cookies.user.id === 107 ? true : false}
                  className='w-100'
                  options={responsabilidadDanioTotal}
                  value={info.catStro}
                  valueRenderer={(selected, _options) => {
                    return selected.length ? selected.map(({ label }) => label) : 'RESPONSABILIDAD';
                  }}
                  onChange={e => {
                    const value = Number(e);
                    let tipoStro = null;
                    if (value[0]) {
                      if (value[0].value === 320 || value[0].value === 300 || value[0].value === 200 || value[0].value === 230 || value[0].value === 233) {
                        tipoStro = 'ACCIDENTE DE TRANSITO';
                      } else if (value[0].value === 500) {
                        tipoStro = 'ROBO TOTAL';
                      } else if (value[0].value === 400) {
                        tipoStro = 'ROBO PARCIAL';
                      } else if (value[0].value === 401 || value[0].value === 402 || value[0].value === 403 || value[0].value === 550 || value[0].value === 551) {
                        tipoStro = 'ROBO PARCIAL INSP';
                      } else if (value[0].value === 600) {
                        tipoStro = 'INCENDIO PARCIAL';
                      } else if (value[0].value === 900) {
                        tipoStro = 'DAÑO TOTAL';
                      } else if (value[0].value === 800) {
                        tipoStro = 'DAÑO PARCIAL';
                      }
                    }
                    setInfo(prevState => ({
                      ...prevState,
                      catStro: e,
                      estado: [],
                      tipoStro: value[0] ? [{ value: tipoStro, label: tipoStro }] : info.tipoStro,
                    }));
                  }}
                />
              ) : info.tipoStro[0] && info.tipoStro[0].value === 'DAÑO PARCIAL' ? (
                <MultiSelect
                  disabled={cookies.user.id === 107 ? true : false}
                  className='w-100'
                  options={responsabilidadDanioParcial}
                  value={info.catStro}
                  valueRenderer={(selected, _options) => {
                    return selected.length ? selected.map(({ label }) => label) : 'RESPONSABILIDAD';
                  }}
                  onChange={e => {
                    const value = Number(e);
                    let tipoStro = null;
                    if (value[0]) {
                      if (value[0].value === 320 || value[0].value === 300 || value[0].value === 200 || value[0].value === 230 || value[0].value === 233) {
                        tipoStro = 'ACCIDENTE DE TRANSITO';
                      } else if (value[0].value === 500) {
                        tipoStro = 'ROBO TOTAL';
                      } else if (value[0].value === 400) {
                        tipoStro = 'ROBO PARCIAL';
                      } else if (value[0].value === 401 || value[0].value === 402 || value[0].value === 403 || value[0].value === 550 || value[0].value === 551) {
                        tipoStro = 'ROBO PARCIAL INSP';
                      } else if (value[0].value === 600) {
                        tipoStro = 'INCENDIO PARCIAL';
                      } else if (value[0].value === 900) {
                        tipoStro = 'DAÑO TOTAL';
                      } else if (value[0].value === 800) {
                        tipoStro = 'DAÑO PARCIAL';
                      }
                    }
                    setInfo(prevState => ({
                      ...prevState,
                      catStro: e,
                      estado: [],
                      tipoStro: value[0] ? [{ value: tipoStro, label: tipoStro }] : info.tipoStro,
                    }));
                  }}
                />
              ) : (
                <MultiSelect
                  disabled={cookies.user.id === 107 ? true : false}
                  className='w-100'
                  options={responsabilidadInput}
                  value={info.catStro}
                  valueRenderer={(selected, _options) => {
                    return selected.length ? selected.map(({ label }) => label) : 'RESPONSABILIDAD';
                  }}
                  onChange={e => {
                    const value = e;
                    let tipoStro = null;
                    if (value[0]) {
                      if (value[0].value === 320 || value[0].value === 300 || value[0].value === 200 || value[0].value === 230 || value[0].value === 233) {
                        tipoStro = 'ACCIDENTE DE TRANSITO';
                      } else if (value[0].value === 500) {
                        tipoStro = 'ROBO TOTAL';
                      } else if (value[0].value === 400) {
                        tipoStro = 'ROBO PARCIAL';
                      } else if (value[0].value === 401 || value[0].value === 402 || value[0].value === 403 || value[0].value === 550 || value[0].value === 551) {
                        tipoStro = 'ROBO PARCIAL INSP';
                      } else if (value[0].value === 600) {
                        tipoStro = 'INCENDIO PARCIAL';
                      } else if (value[0].value === 900) {
                        tipoStro = 'DAÑO TOTAL';
                      } else if (value[0].value === 800) {
                        tipoStro = 'DAÑO PARCIAL';
                      }
                    }
                    setInfo(prevState => ({
                      ...prevState,
                      catStro: e,
                      estado: [],
                      tipoStro: value[0] ? [{ value: tipoStro, label: tipoStro }] : info.tipoStro,
                    }));
                  }}
                />
              )}
              {cookies.user.id === 107 ? (
                <MultiSelect
                  className='w-100'
                  options={estados
                    .filter(estado => [311, 302].includes(estado.id))
                    .map(estado => ({
                      label: estado.nombre,
                      value: estado.id,
                    }))}
                  value={info.estado}
                  valueRenderer={(selected, _options) => {
                    return selected.length ? selected.map(({ label }) => label) : 'ESTADO';
                  }}
                  onChange={e => {
                    if (e.some(option => option.value === 'separator')) return;
                    setInfo(prevState => ({
                      ...prevState,
                      estado: e,
                    }));
                  }}
                />
              ) : (
                <MultiSelect
                  className='w-100'
                  options={
                    info.tipoStro.length > 0
                      ? [
                          ...estados
                            .filter(estado => {
                              const a = codigos.filter(option => info.tipoStro.some(tipo => tipo.value === option.tipoStro));
                              if (a.length > 0) {
                                return a.some(item => {
                                  const estadosPermitidos = item.estados.split(',').map(Number);
                                  return estadosPermitidos.includes(estado.id);
                                });
                              }
                              return false;
                            })
                            .map(estado => ({
                              label: estado.nombre,
                              value: estado.id,
                            })),
                          ...estados
                            .filter(estado => [200, 201, 203].includes(estado.id))
                            .map(estado => ({
                              label: estado.nombre,
                              value: estado.id,
                            })),
                        ]
                      : estados
                          .filter(estado => [200, 201, 203].includes(estado.id))
                          .map(estado => ({
                            label: estado.nombre,
                            value: estado.id,
                          }))
                  }
                  value={info.estado}
                  valueRenderer={(selected, _options) => {
                    return selected.length ? selected.map(({ label }) => label) : 'ESTADO';
                  }}
                  onChange={e => {
                    if (e.some(option => option.value === 'separator')) return;
                    setInfo(prevState => ({
                      ...prevState,
                      estado: e,
                    }));
                  }}
                />
              )}
            </div>
            <div className='conteendorPrimerFilaFiltrosTabla2026'>
              <div className='elementoMultipleTabla2026Filtros'>
                <input
                  class='inputBuscarTabla2026'
                  type='date'
                  placeholder='FECHA STRO'
                  value={info.fechaStro}
                  onChange={e =>
                    setInfo(prevState => ({
                      ...prevState,
                      fechaStro: e.target.value,
                    }))
                  }
                />
                <input
                  class='inputBuscarTabla2026'
                  type='text'
                  placeholder='CODIGO PAS'
                  value={info.codp}
                  onChange={e =>
                    setInfo(prevState => ({
                      ...prevState,
                      codp: e.target.value,
                    }))
                  }
                />
                <MultiSelect
                  disabled={cookies.user.id === 107 ? true : false}
                  className='w-100'
                  options={
                    cookies.user.depto === 'cargas' ? optionsCarga : cookies.user.depto === 'choques' ? optionsChoque : cookies.user.depto === 'contractuales' ? optionsContractuales : optionsCarga
                  }
                  value={info.asignado}
                  valueRenderer={(selected, _options) => {
                    return selected.length ? selected.map(({ label }) => label) : 'ASIGNADO A';
                  }}
                  onChange={e => {
                    setInfo(prevState => ({
                      ...prevState,
                      asignado: e,
                    }));
                  }}
                />
              </div>
              <MultiSelect
                disabled={cookies.user.id === 107 ? true : false}
                className='w-100'
                options={sicobeOptions}
                value={info.sicobe}
                valueRenderer={(selected, _options) => {
                  return selected.length ? selected.map(({ label }) => label) : 'CBT SICOBE';
                }}
                onChange={e => {
                  setInfo(prevState => ({
                    ...prevState,
                    sicobe: e,
                  }));
                }}
              />
              <MultiSelect
                disabled={cookies.user.id === 107 ? true : false}
                className='w-100'
                options={optionsPrioridad}
                value={info.prioridad}
                valueRenderer={(selected, _options) => {
                  return selected.length ? selected.map(({ label }) => label) : 'PRIORIDAD';
                }}
                onChange={e => {
                  setInfo(prevState => ({
                    ...prevState,
                    prioridad: e,
                  }));
                }}
              />
              <MultiSelect
                disabled={cookies.user.id === 107 ? true : false}
                className='w-100'
                options={optionsVencimiento}
                value={info.vencimiento}
                valueRenderer={(selected, _options) => {
                  return selected.length ? selected.map(({ label }) => label) : 'VENCIMIENTO';
                }}
                onChange={e => {
                  setInfo(prevState => ({
                    ...prevState,
                    vencimiento: e,
                  }));
                }}
              />
            </div>
            <div className='conteendorPrimerFilaFiltrosTabla2026'>
              <div className='elementoMultipleTabla2026Filtros'>
                <input
                  class='inputBuscarTabla2026'
                  type='text'
                  placeholder='DOMINIO'
                  value={info.dominio}
                  onChange={e =>
                    setInfo(prevState => ({
                      ...prevState,
                      dominio: e.target.value,
                    }))
                  }
                />
                <input
                  class='inputBuscarTabla2026'
                  type='text'
                  placeholder='DOMINIO 3RO'
                  value={info.dominio3ro}
                  onChange={e =>
                    setInfo(prevState => ({
                      ...prevState,
                      dominio3ro: e.target.value,
                    }))
                  }
                />
                <select
                  value={isCalendar}
                  onChange={e => {
                    setEndDate(null);
                    setStartDate(null);
                    onChange(null);
                    handleChange1(e);
                  }}
                  class='inputBuscarTabla2026'>
                  <option value=''>Calendario</option>
                  {optionsCalendar.map(option => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
              <div></div>
              <button className='botonFiltrarTabla2026 center' style={{ justifySelf: 'center' }} onClick={() => buscar()}>
                FILTRAR
              </button>
              <button className='botonVaciarTabla2026 center' style={{ justifySelf: 'center' }} onClick={() => vaciar()}>
                VACIAR
              </button>
            </div>
          </div>
          <div>
            <p className='center'>
              {isCalendar == 3 ? 'Fecha Enviado a Cotizar' : isCalendar == 2 ? 'Filtrar Fecha Reclamo Recibido' : isCalendar == 1 ? 'Filtrar Fecha Vencimiento' : 'Filtrar Fecha Recepcion'}
            </p>
            <Calendar onClickDay={handleClick} tileClassName={({ date }) => (isInRange(date) ? 'in-range' : '')} className='calendarioTabla2026' />
          </div>
          <div className='d-flex align-items-center' style={{ gap: '13px', flexDirection: 'column' }}>
            <Link to='/solicitudes' className='botonVaciarTabla2026 center' style={{ textDecoration: 'none' }}>
              RECLAMOS
            </Link>
            <button className='botonFiltrarTabla2026 center'>TABLA</button>
            {cookies?.user?.titulo === 'admin' ? (
              <Link to='/ajustes' className='botonCargaHeaderDark center' style={{ textDecoration: 'none', width: '60px' }}>
                <i class='bi bi-gear-fill'></i>
              </Link>
            ) : null}
          </div>
        </div>
      </div>
      <section className='contenedorTabla2026'>
        <table className='tablaFija'>
          <thead className='tablaHeaderTablaDarkContainer'>
            <tr>
              <th className='headerTablaDark'>NRO STRO</th>
              <th className='headerTablaDark'>NRO DEN</th>
              <th className='headerTablaDark'>PZA</th>
              <th className='headerTablaDark'>DOM</th>
              <th className='headerTablaDark'>F.RECEP</th>
              <th className='headerTablaDark'>F.STRO</th>
              <th className='headerTablaDark'>F.REC RECIB</th>
              <th className='headerTablaDark'>F.VTO</th>
              <th className='headerTablaDark'>PRIORIDAD</th>
              <th className='headerTablaDark'>ASIGNADO</th>
              <th className='headerTablaDark'>ESTADO</th>
              <th className='headerTablaDark'>TIPO STRO</th>
              <th className='col-icon'></th>
            </tr>
          </thead>
        </table>
        <div className='contenedorBodyTabla2026 my-scrollbar'>
          {denuncias.length > 0 ? (
            <table className='tablaFija'>
              <tbody>
                {denuncias.slice(itemOffset, Number(itemOffset + 200)).map(d => (
                  <ComponenteTablaLight amp={ampSinLeer} updatedList={denuncias} estados={estados} stro={d} key={d.id} />
                ))}
              </tbody>
            </table>
          ) : null}
          {buscando ? (
            <div>
              <div className='center'>
                <div className='spinner-border text-success center' role='status'></div>
              </div>
            </div>
          ) : null}
          {sinResultados ? <h2 className='center'>Sin Resultados</h2> : null}
        </div>
        <div className='d-flex justify-content-between mt-5'>
          <div className='d-flex paginateTablaDark'>
            <h6>Cantidad total: {denuncias.length}</h6>
            <h6 className='ps-4'>Cargados: {denuncias.filter(d => d.nroStro !== null).length}</h6>
            <h6 className='ps-4'>Duplicados: {denuncias.filter(d => d.estados.includes(204)).length}</h6>
            <h6 className='ps-4'>Sin Leer: {denuncias.filter(d => d.estados.includes(200)).length}</h6>
          </div>
          {isCalendar == 3 && startDate ? (
            <button className='btn btn-sm btn-primary' onClick={exportToExcel}>
              Exportar Excel
            </button>
          ) : null}
          <ReactPaginate
            containerClassName={'customDark-paginate'}
            pageClassName={'customDark-page'}
            pageLinkClassName={'customDark-page-link'}
            activeClassName={'active'}
            previousClassName={'customDark-prev'}
            nextClassName={'customDark-next'}
            breakLabel='...'
            previousLabel='<'
            nextLabel='>'
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            marginPagesDisplayed={1}
            pageCount={pageCount}
            renderOnZeroPageCount={null}
          />
        </div>
      </section>
    </main>
  );
}
